module.exports = __webpack_public_path__ + "img/black_logo.4a547f08.png";